import { lexieImages } from '@/assets/images';
var normalHearingIcon = lexieImages.normalHearingIcon, mildHearingIcon = lexieImages.mildHearingIcon, severeHearingIcon = lexieImages.severeHearingIcon;
export var hearingLevelsExplained = [
    {
        title: 'Normal hearing',
        description: 'You can hear conversations with good clarity when there is background noise.',
        color: 'text-green',
        icon: normalHearingIcon,
    },
    {
        title: 'Mild-to-moderate hearing loss',
        description: 'You may have difficulty clearly following conversations when there is background noise.',
        color: 'text-orange',
        icon: mildHearingIcon,
    },
    {
        title: 'Severe hearing difficulties',
        description: 'You have severe difficulty following conversations when there is background noise.',
        color: 'text-red',
        icon: severeHearingIcon,
    },
];
